import { injectable } from 'inversify';
import 'reflect-metadata';
import { Response } from '@/_shared/_api/models/response.model';
import axiosClient from './axios-client';
import { ERRORS } from '../constants/errors/error-messages.constants';
import LogHelper from '../helpers/log.helper';
import { UserNotificationApiResponse } from '../_api/models/user-notification.model';
import { UpdateNotificationVisibilityStatus } from '../models/user-notification/update-visibility-notification-status.model';

@injectable()
export class UserNotificationService {
  logger: LogHelper;

  constructor(logger = new LogHelper()) {
    this.logger = logger;
  }

  async getUserNotification(): Promise<Response<UserNotificationApiResponse>> {
    try {
      const response = await axiosClient.get<
        Response<UserNotificationApiResponse>
      >('/api/user-notification');
      return response.data;
    } catch {
      throw new Error(ERRORS.unexpectedError);
    }
  }

  async updateNotificationVisibilityStatus(
    request: UpdateNotificationVisibilityStatus
  ): Promise<Response<boolean>> {
    try {
      const response = await axiosClient.put(
        '/api/user-notification/update-status',
        request,
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );

      return response;
    } catch {
      throw new Error(ERRORS.unexpectedError);
    }
  }
}
